export { HeadingBlock, type HeadingBlockProps } from './HeadingBlock';
